import React, { Component } from 'react';
import {localization} from '../../Frames/localization'
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

class FormDialog extends Component{
  constructor(props) {
    super(props);
    this.state = {
        textField: '',
    };         
    this.onChangetextField = this.onChangetextField.bind(this);
    this.onSubsmit = this.onSubsmit.bind(this);
  }
  onChangetextField(event) {
    this.setState({textField: event.target.value});
  }
  onSubsmit(){
    this.props.comparisonCode(this.state.textField)
  };
    render(){
        var tr = {
            Cancel: localization.GetTranslate('Alert.cancel'),
            OK: localization.GetTranslate('Alert.confirm'),
            Code: localization.GetTranslate('Statistics.Code')
        } 
  return (
    <div>
      <Dialog open={this.props.open} onClose={this.props.handleClose} aria-labelledby="form-dialog-title" disableBackdropClick={true}>
        <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            onChange={this.onChangetextField}
            margin="dense"
            id="name"
            name="textField"
            label={tr.Code}
            type="text"
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.handleClose} color="primary">
            {tr.Cancel}
          </Button>
          <Button onClick={this.onSubsmit} color="primary">
            {tr.OK}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
    }
}
export default FormDialog;